var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGatewaysIcon = function SvgGatewaysIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3AACC8",
    strokeWidth: 2,
    clipPath: "url(#gateways-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 10 8.66 5v10L20 30l-8.66-5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.504 22.496a3.53 3.53 0 0 1 4.992 0M15.004 19.996a7.065 7.065 0 0 1 9.992 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gateways-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M8 8h24v24H8z"
  })))));
};
export { SvgGatewaysIcon as ReactComponent };
export default __webpack_public_path__ + "ec07ba3d081b778c1a45f0bed39e74e6.svg";